import { ImageOff } from "lucide-react"

/**
 * Visible, non-interactive placeholder shown when a markdown image `src` cannot
 * be rendered or a remote image fails to load. Surfacing the miss keeps a
 * mismatched or broken image from silently vanishing. Rendered as phrasing
 * content so it is valid both inline (inside `<p>`) and as a standalone block.
 */
export function BlogImageFallback({ alt }: { alt: string }) {
  return (
    <span
      role="img"
      aria-label={alt || "Image unavailable"}
      className="my-10 flex flex-col items-center justify-center gap-2 rounded-lg border border-dashed border-gray-300 bg-gray-50 px-6 py-10 text-center"
    >
      <ImageOff className="size-6 text-gray-400" aria-hidden="true" />
      <span className="text-sm text-gray-500">{alt || "Image unavailable"}</span>
    </span>
  )
}
